import store from '@Store';
import { memorizeForNg } from '@Utils/Decorators/NgServices';

import { fetchRelativeContexts, clearRelativeContext } from './RelativeContextActions';

import { relativeContextByName } from './RelativeContextSelectors';

const relativeContextByNameNg = memorizeForNg(relativeContextByName);

const relativeContextService = {
  async getRelativeContexts(params, history) {
    const {
      context,
      hitSetKey,
      resultName,
      databaseId,
    } = params;
    const requiredParams = {
      context,
      hitSetKey,
      resultName,
      databaseId,
    };

    try {
      const result = await store.dispatch(fetchRelativeContexts(requiredParams, history));

      return result && result.toJS();
    } catch (e) {
      Logger.reject(e);
    }
  },

  clearSavedContexts() {
    store.dispatch(clearRelativeContext());
  },

  getContextByName(name, hitSetKey) {
    return relativeContextByNameNg({ contextName: name, hitSetKey });
  },
};

export default relativeContextService;
